import React from 'react';
import './fake-combo.scss';

interface FakeComboProps {
    leftText: string;
    rightText: string;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export function FakeCombo({leftText, rightText, onClick}: FakeComboProps) {
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, sonarjs/mouse-events-a11y
    return <div className="fake-combo" onClick={onClick}>
        <div className="ticket-main-text ellipsify" title={leftText}>{leftText}</div>
        <div>
            {rightText && <span>{rightText}</span>}

            <i className="fas fa-caret-down"></i>
        </div>
    </div>;
};